module.exports = __webpack_public_path__ + "static/media/arrow-square-up.69f96d56.svg";